<template>
  <div class="citizenship-application">
    <div class="page-container">
      <h1 class="page-title">入籍申请</h1>
      
      <section class="content-section">
        <h2>入籍申请简介</h2>
        <p>加拿大入籍是指在满足一定年限后，永久居民加入加拿大国籍，换发加拿大护照，成为加拿大公民的过程。入籍成为加拿大公民后，即享有公民的投票权，无需更新枫叶卡或满足枫叶卡要求的居住时间，也可享受加拿大护照带来的旅行便利。</p>
      </section>

      <section class="content-section">
        <h2>入籍条件</h2>
        <ul>
          <li>申请人必须年龄在18岁或以上，18岁以下的儿童需要由父母或者法定监护人代为申请；</li>
          <li>申请人必须是加拿大永久居民；</li>
          <li>18岁至54岁的申请人需要通过入籍考试；</li>
          <li>在申请入籍前5年内，申请者必须在加拿大居住满3年（即1,095天）以上，其中至少2年的居留时间是永久居民身份居住的；</li>
          <li>申请者需要在申请之前的5年内有至少3年的报税记录；</li>
          <li>在取得永久居民身份之前，对于旅游、学习、或者工作等短暂居留时间在加拿大居住的时间可以算作法定2天计算为1天，但是多不可累积超过365天；</li>
          <li>对于年龄在18-54岁之间的申请者必须提交可以证明自己达到英语或法语语言能力的语言能力证明，在听说方面需达到4分的水平；</li>
          <li>申请人必须在申请时签署声明；</li>
          <li>申请人必须对加拿大的历史、制度、传统以及公民权利和责任有一定程度的了解。</li>
        </ul>
      </section>

      <section class="content-section">
        <h2>申请注意事项</h2>
        <ul>
          <li>确保提供的所有信息准确无误，任何虚假陈述都可能导致申请被拒；</li>
          <li>准备充分的证明文件，包括身份证明、居住证明、语言能力证明等；</li>
          <li>认真准备入籍考试，熟悉加拿大历史、地理、政治制度等知识；</li>
          <li>按时缴纳申请费用；</li>
          <li>保持通讯地址更新，确保能及时收到移民局的通知。</li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CitizenshipApplicationView'
}
</script>

<style lang="less" scoped>
.citizenship-application {
  padding: 40px 20px;
  background-color: #f5f7fa;

  .page-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .page-title {
    font-size: 32px;
    color: #333;
    margin-bottom: 40px;
    text-align: center;
  }

  .content-section {
    margin-bottom: 40px;
    background: #fff;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

    h2 {
      font-size: 24px;
      color: #333;
      margin-bottom: 20px;
      padding-bottom: 10px;
      border-bottom: 2px solid #9e9e9e;
    }

    p {
      font-size: 16px;
      line-height: 1.8;
      color: #666;
      margin-bottom: 20px;
    }

    ul {
      list-style-type: disc;
      padding-left: 20px;
      margin-bottom: 20px;

      li {
        font-size: 16px;
        line-height: 1.8;
        color: #666;
        margin-bottom: 10px;
      }
    }
  }
}
</style>